import { useQuery } from "@tanstack/react-query"

import { useAuth } from "src/context/AuthContext"

export function useAnnotationTags() {
  const { api } = useAuth()

  return useQuery({
    queryFn: async () => {
      const response = await api.getAnnotationTags()
      if (response.kind !== "ok") {
        throw new Error("Failed to fetch annotation tags")
      }
      return response.tags
    },
    queryKey: ["annotation-tags"],
  })
}
